import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const giftCardAPI = axios.create({
  baseURL: `${API_BASE_URL}/gift-card`,
  timeout: Number(process.env.REACT_APP_API_TIMEOUT) || 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para agregar token de autenticación cuando esté disponible
giftCardAPI.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor para manejo de errores
giftCardAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('Gift Card Service Error:', error);
    return Promise.reject(error);
  }
);

export const giftCardService = {
  // Obtener configuración (montos, límites)
  getConfig: async () => {
    try {
      const response = await giftCardAPI.get('/config');
      return response.data;
    } catch (error) {
      throw new Error('Error al obtener la configuración: ' + error.message);
    }
  },

  // Comprar gift card
  purchase: async (data) => {
    try {
      const response = await giftCardAPI.post('/purchase', data);
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      throw new Error(message);
    }
  },

  // Subir comprobante de pago
  uploadReceipt: async (id, receiptUrl) => {
    try {
      const response = await giftCardAPI.post(`/${id}/upload-receipt`, { receiptUrl });
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || error.message;
      throw new Error(message);
    }
  },

  // Validar código y ver saldo
  validate: async (code) => {
    try {
      const response = await giftCardAPI.get(`/validate/${code}`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 429) {
        const msg = error.response?.data?.message || 'Demasiados intentos. Esperá unos minutos antes de volver a intentar.';
        throw new Error(msg);
      }
      throw new Error('Error al validar el código: ' + error.message);
    }
  },

  // Obtener mis gift cards (usuario autenticado)
  getMyGiftCards: async () => {
    try {
      const response = await giftCardAPI.get('/my');
      return response.data;
    } catch (error) {
      throw new Error('Error al obtener mis gift cards: ' + error.message);
    }
  },
};

export default giftCardService;
